import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const COPY = {
  de: {
    overline: "— Fehler 404",
    title: "Diese Seite gibt es nicht.",
    body: "Möglicherweise wurde die Seite verschoben oder der Link ist veraltet. Auf unserer Startseite finden Sie alle 11 Verfahren der Fritz Kamm AG.",
    home: "Zur Startseite",
  },
  en: {
    overline: "— Error 404",
    title: "This page doesn't exist.",
    body: "The page may have been moved or the link is out of date. You'll find all 11 Fritz Kamm AG processes on our homepage.",
    home: "Back to homepage",
  },
  fr: {
    overline: "— Erreur 404",
    title: "Cette page n'existe pas.",
    body: "La page a peut-être été déplacée ou le lien est obsolète. Vous trouverez les 11 procédés de Fritz Kamm SA sur notre page d'accueil.",
    home: "Retour à l'accueil",
  },
};

export default function NotFound() {
  const { lang } = useI18n();
  const c = COPY[lang] || COPY.de;
  return (
    <div className="min-h-screen bg-[#0E0E10] text-white flex items-center justify-center px-6">
      <div className="max-w-xl w-full">
        <div className="overline mb-5">{c.overline}</div>
        <div className="font-display text-[120px] sm:text-[180px] leading-[0.9] font-semibold tracking-[-0.05em] outline-text">
          404
        </div>
        <h1 className="mt-6 font-display text-3xl sm:text-4xl font-semibold tracking-tight">
          {c.title}
        </h1>
        <p className="mt-4 text-zinc-400 text-base leading-relaxed max-w-md">
          {c.body}
        </p>
        <Link
          to="/"
          data-testid="notfound-home"
          className="mt-10 inline-flex items-center gap-2 bg-white text-black px-6 py-3.5 text-sm font-semibold hover:bg-zinc-200 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
          {c.home}
        </Link>
      </div>
    </div>
  );
}
